module.exports = __webpack_public_path__ + "static/media/energy5.5bcbe098.jpeg";